const subscriptionPlans = [
    // Gym Freaks
    {
      _id: "6763c3dfe1ca466d3076f4c1",
      itemName: "Gym Nutrition Starter Pack",
      mainCategory: "Subscription",
      numberOfDeliveries: 1,
      numberOfProductPackets: 10,
      frequencyPerWeek: 3,
      duration: "One Month",
      category: "Gym Freaks",
      description: `
        A tailored selection of protein-rich and energy-packed products for gym enthusiasts:
        1. Broccoli Soup: High in vitamins for post-workout recovery.
        2. Sattu Beverage: Protein-rich, perfect for muscle building.
        3. Little Millet Soup: Light and nutritious, aids in digestion.
        4. Pumpkin Soup: Antioxidant-rich to reduce inflammation.
        5. Jowar Porridge: Provides sustained energy during workouts.
      `,
      imagePath: "https://surveyappanswers.blob.core.windows.net/jaavapotmenuimages/1734591455330_Essentialboost.png",
      actualPrice: 500,
      discountedPrice: 450,
      quantity: 1200,
      subscriptionType: "Basic",
      postedBy: "help.jaavapot@gmail.com",
      __v: 0,
    },
    {
      _id: "6763c3dfe1ca466d3076f4c2",
      itemName: "Gym Pro Pack",
      mainCategory: "Subscription",
      numberOfDeliveries: 1,
      numberOfProductPackets: 20,
      frequencyPerWeek: 5,
      duration: "Quarterly",
      category: "Gym Freaks",
      description: `
        Advanced meal options to boost performance and recovery:
        1. Ragi Ambali: Packed with calcium, great for bone health.
        2. Sattu Beverage: Refreshing and protein-packed.
        3. Foxtail Millet Porridge: Balanced carbs for pre-workout energy.
        4. Oats Porridge: Keeps you fueled throughout the day.
        5. Bajra Porridge: Aids in muscle repair with slow-digesting carbs.
      `,
      imagePath: "https://surveyappanswers.blob.core.windows.net/jaavapotmenuimages/1734591455330_Essentialboost.png",
      actualPrice: 1500,
      discountedPrice: 1300,
      quantity: 3500,
      subscriptionType: "Standard",
      postedBy: "help.jaavapot@gmail.com",
      __v: 0,
    },
  
    // Old Generation
    {
      _id: "6763c3dfe1ca466d3076f4c3",
      itemName: "Senior Essentials Pack",
      mainCategory: "Subscription",
      numberOfDeliveries: 1,
      numberOfProductPackets: 15,
      frequencyPerWeek: 3,
      duration: "One Month",
      category: "Old Generation",
      description: `
        Healthy, easy-to-digest options for seniors:
        1. Jowar Porridge: High in fiber, great for gut health.
        2. Broccoli Soup: Supports immunity and detoxification.
        3. Ragi Ambali: Strengthens bones and aids digestion.
        4. Bajra Porridge: Keeps energy levels steady throughout the day.
        5. Little Millet Soup: Gentle on the stomach, nutrient-dense.
      `,
      imagePath: "https://surveyappanswers.blob.core.windows.net/jaavapotmenuimages/1734591455330_Essentialboost.png",
      actualPrice: 700,
      discountedPrice: 600,
      quantity: 1400,
      subscriptionType: "Basic",
      postedBy: "help.jaavapot@gmail.com",
      __v: 0,
    },
    {
      _id: "6763c3dfe1ca466d3076f4c4",
      itemName: "Golden Years Pack",
      mainCategory: "Subscription",
      numberOfDeliveries: 1,
      numberOfProductPackets: 25,
      frequencyPerWeek: 5,
      duration: "Quarterly",
      category: "Old Generation",
      description: `
        Designed to enhance wellness and vitality in seniors:
        1. Pumpkin Soup: Rich in antioxidants for immunity.
        2. Sattu Beverage: A refreshing and hydrating drink.
        3. Foxtail Millet Porridge: Supports heart health.
        4. Broccoli Soup: Packed with nutrients for overall wellness.
        5. Bajra Porridge: Helps maintain steady energy.
      `,
      imagePath: "https://surveyappanswers.blob.core.windows.net/jaavapotmenuimages/1734591455330_Essentialboost.png",
      actualPrice: 1800,
      discountedPrice: 1600,
      quantity: 5000,
      subscriptionType: "Standard",
      postedBy: "help.jaavapot@gmail.com",
      __v: 0,
    },
  
    // Kids
    {
      _id: "6763c3dfe1ca466d3076f4c5",
      itemName: "Kids Delight Pack",
      mainCategory: "Subscription",
      numberOfDeliveries: 1,
      numberOfProductPackets: 20,
      frequencyPerWeek: 4,
      duration: "One Month",
      category: "Kids",
      description: `
        Delicious and nutritious options for growing kids:
        1. Oats Porridge: A wholesome breakfast option.
        2. Pumpkin Soup: A fun and tasty immunity booster.
        3. Foxtail Millet Porridge: Easy to digest and nutritious.
        4. Bajra Porridge: Provides energy for active playtime.
        5. Ragi Ambali: Keeps them hydrated and strong.
      `,
      imagePath: "https://surveyappanswers.blob.core.windows.net/jaavapotmenuimages/1734591455330_Essentialboost.png",
      actualPrice: 800,
      discountedPrice: 700,
      quantity: 1600,
      subscriptionType: "Basic",
      postedBy: "help.jaavapot@gmail.com",
      __v: 0,
    },
    {
      _id: "6763c3dfe1ca466d3076f4c6",
      itemName: "Kids Active Pack",
      mainCategory: "Subscription",
      numberOfDeliveries: 1,
      numberOfProductPackets: 30,
      frequencyPerWeek: 5,
      duration: "Half Year",
      category: "Kids",
      description: `
        Nutritious meals to fuel your child's growth and activities:
        1. Sattu Beverage: A fun and protein-packed treat.
        2. Pumpkin Soup: Great for immunity and eye health.
        3. Ragi Ambali: Keeps them hydrated and supports bones.
        4. Jowar Porridge: Helps with sustained energy throughout the day.
        5. Broccoli Soup: An easy way to add greens to their diet.
      `,
      imagePath: "https://surveyappanswers.blob.core.windows.net/jaavapotmenuimages/1734591455330_Essentialboost.png",
      actualPrice: 2000,
      discountedPrice: 1800,
      quantity: 5000,
      subscriptionType: "Premium",
      postedBy: "help.jaavapot@gmail.com",
      __v: 0,
    },
  
    // Women General
    {
      _id: "6763c3dfe1ca466d3076f4c7",
      itemName: "Women's Wellness Starter",
      mainCategory: "Subscription",
      numberOfDeliveries: 1,
      numberOfProductPackets: 15,
      frequencyPerWeek: 3,
      duration: "One Month",
      category: "Women General",
      description: `
        Nutritious options for the busy, health-conscious woman:
        1. Broccoli Soup: Antioxidant-rich and detoxifying.
        2. Bajra Porridge: Provides sustained energy.
        3. Ragi Ambali: Supports hydration and bone health.
        4. Pumpkin Soup: Promotes skin and immunity health.
        5. Foxtail Millet Porridge: Easy-to-digest and nutritious.
      `,
      imagePath: "https://surveyappanswers.blob.core.windows.net/jaavapotmenuimages/1734591455330_Essentialboost.png",
      actualPrice: 600,
      discountedPrice: 500,
      quantity: 1200,
      subscriptionType: "Basic",
      postedBy: "help.jaavapot@gmail.com",
      __v: 0,
    },
    {
      _id: "6763c3dfe1ca466d3076f4c8",
      itemName: "Women's Wellness Deluxe",
      mainCategory: "Subscription",
      numberOfDeliveries: 1,
      numberOfProductPackets: 30,
      frequencyPerWeek: 5,
      duration: "Annual",
      category: "Women General",
      description: `
        A luxurious pack tailored to meet women's health needs:
        1. Ragi Ambali: Maintains hydration and boosts calcium levels.
        2. Broccoli Soup: Packed with essential vitamins and nutrients.
        3. Sattu Beverage: Refreshing and protein-packed for energy.
        4. Little Millet Soup: Supports digestion and provides lasting nutrition.
        5. Jowar Porridge: A fiber-rich option for balanced meals.
      `,
      imagePath: "https://surveyappanswers.blob.core.windows.net/jaavapotmenuimages/1734591455330_Essentialboost.png",
      actualPrice: 2400,
      discountedPrice: 2100,
      quantity: 6000,
      subscriptionType: "Premium",
      postedBy: "help.jaavapot@gmail.com",
      __v: 0,
    },
  ];

  export default subscriptionPlans;